import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import yyly from '@/pages/yyly/yyly'
import cpzy from '@/pages/cpzy/cpzy'
import detail from '@/pages/cpzy/detail'
import news from '@/pages/news/news'
import nText from '@/pages/news/nText'
import about from '@/pages/about/about'
import joinIn from '@/pages/joinIn/joinIn'
import VR from '@/pages/VR/index'
import cpProgram from '@/pages/cpProgram/cpProgram'
import fanDetail from '@/pages/cpProgram/fanDetail'
import callMe from '@/pages/callMe/index'
import programDetail from '@/pages/cpProgram/programDetail'
import ProductCenter from '@/pages/home/home_product_center'
import ProductList from '@/pages/home/home_product_center/productList'
import ProductSearchList from '@/pages/home/home_product_center/productSearchList'
import ProductDetails from '@/pages/home/home_product_center/productDetails'
import CustomerService from '@/pages/home/home_customer_service'
const originalPush = Router.prototype.push

//解决报错信息：NavigationDuplicated: Avoided redundant navigation to current location
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/yyly',
      name: 'yyly',
      component: yyly
    },
    {
      path: '/cpzy',
      name: 'cpzy',
      component: cpzy
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/nText',
      name: 'nText',
      component: nText
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/joinIn',
      name: 'joinIn',
      component: joinIn
    },
    {
      path: '/VR',
      name: 'VR',
      component: VR
    },
    {
      path: '/fanDetail',
      name: 'fanDetail',
      component: fanDetail
    },
    // 产品中心
    {
      path: '/prod_center',
      name: 'prod_center',
      component: ProductCenter
    },
    {
      path: '/prod_search_list',
      name: 'prod_list',
      component: ProductSearchList
    },
    {
      path: '/prod_list',
      name: 'prod_list',
      component: ProductList
    },
    {
      path: '/prod_details',
      name: 'prod_details',
      component: ProductDetails
    },
    // 产品方案
    {
      path: '/cpProgram',
      name: 'cpProgram',
      component: cpProgram
    },
    // 客户服务
    {
      path: '/customer_service',
      name: 'customer_service',
      component: CustomerService
    },
    // 联系我们
    {
      path: '/callMe',
      name: 'callMe',
      component: callMe,
      meta: {
        keepAlive: true
      },
    },
    // 留言记录
    {
      path: '/message-record',
      name: 'messageRecord',
      meta: {
        keepAlive: true
      },
      component: () => import(/* webpackChunkName: "message-record-page" */ '@/pages/messageRecord/index.vue'),
    },
    {
      path: '/programDetail',
      name: 'programDetail',
      component: programDetail
    },
    {
      path: '/search',
      name: 'searchList',
      meta: {
        keepAlive: true
      },
      component: () => import(/* webpackChunkName: "search-page" */ '@/pages/search/SearchList.vue'),
    },
  ],
  scrollBehavior(to,from,savedPosition){
    if(savedPosition){
      return savedPosition
    }else{
      return {x:0,y:0}
    }
  }
})





// WEBPACK FOOTER //
// ./src/router/index.js